"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.stageMessages = exports.Stage = void 0;
const schema_1 = require("../../../schema");
var Stage;
(function (Stage) {
    Stage["I"] = "I";
    Stage["II"] = "II";
    Stage["III"] = "III";
    Stage["IV"] = "IV";
})(Stage || (exports.Stage = Stage = {}));
exports.stageMessages = {
    [Stage.I]: {
        id: "htx.currentCardiologicalState.nyha.stage.I",
        defaultMessage: "I. stádium"
    },
    [Stage.II]: {
        id: "htx.currentCardiologicalState.nyha.stage.II",
        defaultMessage: "II. stádium"
    },
    [Stage.III]: {
        id: "htx.currentCardiologicalState.nyha.stage.III",
        defaultMessage: "III. stádium"
    },
    [Stage.IV]: {
        id: "htx.currentCardiologicalState.nyha.stage.IV",
        defaultMessage: "IV. stádium"
    }
};
const stage = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Stage.I),
    schema_1.Schema.singleChoiceItem(Stage.II),
    schema_1.Schema.singleChoiceItem(Stage.III),
    schema_1.Schema.singleChoiceItem(Stage.IV)
])
    .interpretation({ vocab: "htx", code: "nyha_stage" })
    .tag({ vocab: "snomed", code: "762994006" })
    .tag({ vocab: "loinc", code: "88020-3" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ stage });
